// ==============================|| OVERRIDES - TABLE CELL ||============================== //

export default function TableHead(theme) {
  return {
    MuiTableHead: {
      styleOverrides: {
        root: {
          // Header acompanha a superfície do card (igual à lista de tarefas de Projetos).
          // grey[50] no dark = #141414 (quase preto) — não usar.
          backgroundColor: theme.vars!.palette.background.paper,
          borderTop: '1px solid',
          borderTopColor: theme.vars!.palette.divider,
          borderBottom: '2px solid',
          borderBottomColor: theme.vars!.palette.divider
        }
      }
    }
  };
}
